import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import { _MainNavItemMobile } from "../layout";
import { _Transition } from "../components";
import useToggle from "../../hooks/Toggle";

interface IMainNavMobileProps {
    Data: Dati.IDatiMenu[];
}

const useStyles = makeStyles({
    appBar: {
        position: "relative"
    }
});

export const _MainNavMobile: React.FC<IMainNavMobileProps> = ({ Data }) => {
    const classes = useStyles();
    const { open, toggle } = useToggle();

    return (
        <>
            <IconButton aria-label="menu" color="secondary" onClick={toggle}>
                <MenuIcon />
            </IconButton>
            <Dialog fullScreen open={open} TransitionComponent={_Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar variant="dense">
                        <IconButton edge="start" color="inherit" onClick={toggle} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <List component="nav">
                    {Data.map(item =>
                        item.Azioni == undefined || item.Azioni.length == 0 || item.ID_Funzione == undefined ? (
                            <ListItem button key={item.ID_Menu} component="a" href={item.Indirizzo} onClick={toggle}>
                                <ListItemText primary={Trad.Trad(item.Voce)} />
                            </ListItem>
                        ) : (
                            <_MainNavItemMobile Data={item} ToggleMenu={toggle} key={item.ID_Menu} />
                        )
                    )}
                </List>
            </Dialog>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/MainNavMobile.tsx